/*  @flow */

import * as React from 'react';

import {
  assetAssignment,
  assetQuality,
  assetStatus,
  assetsByLocation,
  assetsByProject,
  assetsByTypeBar,
  assetsByUser,
  contracts,
  costCenters,
  projects,
  tradingAccounts,
  assetsByModel,
  calibrations,
  assetsByUserType,
} from 'permissions/dashboard';
import type { RoleList } from 'permissions/defs';

import AssetAssignment from '../AssetAssignment/AssetAssignment';
import AssetsByLocation from '../AssetsByLocation/AssetsByLocation';
import AssetsByModel from '../AssetsByModel/AssetsByModel';
import AssetsByProject from '../AssetsByProject/AssetsByProject';
import AssetsByTypeBar from '../AssetsByTypeBar/AssetsByTypeBar';
import AssetsByUser from '../AssetsByUser/AssetsByUser';
import AssetsByUserType from '../AssetsByUserType/AssetsByUserType';
import AssetQuality from '../AssetQuality/AssetQuality';
import AssetStatus from '../AssetStatus/AssetStatus';
import Calibrations from '../Calibrations/Calibrations';
import Contracts from '../Contracts/Contracts';
import CostCenters from '../CostCenters/CostCenters';
import Projects from '../Projects/Projects';
import TradingAccounts from '../TradingAccounts/TradingAccounts';

export type AvailableWidget = {
  type: string,
  data: string,
  permissions: RoleList,
  component: React.ComponentType<any>,
};

const availableWidgets: AvailableWidget[] = [
  {
    type: 'widget',
    data: 'AssetAssignment',
    permissions: assetAssignment,
    component: function AssetAssignmentWidget() {
      return (
        <AssetAssignment
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetAssignment' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetQuality',
    permissions: assetQuality,
    component: function AssetQualityWidget() {
      return (
        <AssetQuality
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetQuality' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetStatus',
    permissions: assetStatus,
    component: function AssetStatusWidget() {
      return (
        <AssetStatus
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetStatus' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByLocation',
    permissions: assetsByLocation,
    component: function AssetsByLocationWidget() {
      return (
        <AssetsByLocation
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByLocation' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByProject',
    permissions: assetsByProject,
    component: function AssetsByProjectWidget() {
      return (
        <AssetsByProject
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByProject' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByTypeBar',
    permissions: assetsByTypeBar,
    component: function AssetsByTypeBarWidget() {
      return (
        <AssetsByTypeBar
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByTypeBar' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByUser',
    permissions: assetsByUser,
    component: function AssetsByUserWidget() {
      return (
        <AssetsByUser
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByUser' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'Contracts',
    permissions: contracts,
    component: function ContractsWidget() {
      return (
        <Contracts
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'Contracts' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'CostCenters',
    permissions: costCenters,
    component: function CostCentersWidget() {
      return (
        <CostCenters
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'CostCenters' }}
        />
      );
    },
  },
  // {
  //   type: 'widget',
  //   data: 'ProjectFinance',
  //   permissions: projectFinance,
  //   component: function ProjectFinanceWidget() {
  //     return <ProjectFinance size="thumbnail" widgetItem={{position: 1, variant: 'default', widget: 'ProjectFinance'}} />;
  //   },
  // },
  {
    type: 'widget',
    data: 'Projects',
    permissions: projects,
    component: function ProjectsWidget() {
      return (
        <Projects
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'Projects' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'TradingAccounts',
    permissions: tradingAccounts,
    component: function TradingAccountsWidget() {
      return (
        <TradingAccounts
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'TradingAccounts' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByModel',
    permissions: assetsByModel,
    component: function AssetsByModelWidget() {
      return (
        <AssetsByModel
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByModel' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'Calibrations',
    permissions: calibrations,
    component: function CalibrationsWidget() {
      return (
        <Calibrations
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'Calibrations' }}
        />
      );
    },
  },
  {
    type: 'widget',
    data: 'AssetsByUserType',
    permissions: assetsByUserType,
    component: function AssetsByUserTypeWidget() {
      return (
        <AssetsByUserType
          size="thumbnail"
          widgetItem={{ position: 1, variant: 'default', widget: 'AssetsByUserType' }}
        />
      );
    },
  },
];

export default availableWidgets;
